module.exports = __webpack_public_path__ + "4aab17718b8db9a07bfe95c66fa4d3ce.svg";